// Module
var code = "<external-users\n  customer-id=\"vm.customer.id\"\n  customer-name=\"vm.customer.name\"\n></external-users>\n";
// Exports
module.exports = code;